import Icon from './Icon';

/** Nothing here yet — with the action that would change that, when there is one. */
export function EmptyState({ icon = 'inbox', title, message, action }) {
  return (
    <div className="state-block">
      <div className="state-icon">
        <Icon name={icon} />
      </div>
      <div className="state-title">{title}</div>
      {message && <div className="state-text">{message}</div>}
      {action}
    </div>
  );
}

/**
 * Something failed. The message comes from the API where possible, so the user
 * sees the real reason rather than a generic apology.
 */
export function ErrorState({ error, onRetry, title = 'Could not load this' }) {
  return (
    <div className="state-block">
      <div className="state-icon" style={{ background: 'var(--danger-bg)', color: 'var(--danger-fg)' }}>
        <Icon name="error" />
      </div>
      <div className="state-title">{title}</div>
      <div className="state-text">{error?.message || 'Something went wrong.'}</div>
      {error?.requestId && (
        <div style={{ fontSize: 11, color: 'var(--ink-subtle)' }}>Reference: {error.requestId}</div>
      )}
      {onRetry && (
        <button type="button" className="btn-ghost" onClick={onRetry} style={{ marginTop: 6 }}>
          <Icon name="refresh" style={{ fontSize: 16 }} />
          Try again
        </button>
      )}
    </div>
  );
}

/** Table placeholder shaped like the rows it replaces, so nothing jumps. */
export function TableSkeleton({ rows = 6, columns = 5 }) {
  return (
    <div className="table-wrap">
      <table className="data-table">
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r}>
              {Array.from({ length: columns }).map((__, c) => (
                <td key={c}>
                  <div
                    className="skeleton"
                    style={{ height: c === 0 ? 38 : 14, width: c === 0 ? '70%' : `${50 + ((r + c) % 4) * 10}%` }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function CardSkeleton({ count = 6, height = 220 }) {
  return (
    <div className="media-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton" style={{ height, borderRadius: 'var(--radius-lg)' }} />
      ))}
    </div>
  );
}

export function KpiSkeleton({ count = 4 }) {
  return (
    <div className="kpi-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton" style={{ height: 108, borderRadius: 'var(--radius-lg)' }} />
      ))}
    </div>
  );
}

export function PageLoader({ label = 'Loading' }) {
  return (
    <div className="state-block" style={{ minHeight: '50vh' }}>
      <span className="spinner spinner--brand" style={{ width: 26, height: 26 }} />
      <div className="state-text">{label}…</div>
    </div>
  );
}
